import { Check } from "lucide-react";

import { useIsTourActive, VISIT_TOUR_ID } from "@src/features/tourguide";
import { cn } from "@src/shared/lib/utils";

import type { AuthenticatedHeaderStepperV2Props } from "./AuthenticatedLayout.types";

export function AuthenticatedHeaderStepperV2({
  steps,
  currentStepId,
}: AuthenticatedHeaderStepperV2Props) {
  const currentIndex = steps.findIndex((step) => step.id === currentStepId);

  const isVisitTourActive = useIsTourActive(VISIT_TOUR_ID);

  if (!isVisitTourActive) return null;

  return (
    <ol className="flex items-center gap-2" aria-label="Visit progress">
      {steps.map((step, index) => {
        const isComplete = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <li key={step.id} className="flex items-center gap-2">
            <span
              className={cn(
                "flex size-5 items-center justify-center rounded-full border font-mono text-[10px] font-semibold",
                isComplete &&
                  "border-success bg-success text-success-foreground",
                isCurrent && "border-foreground bg-foreground text-background",
                !isComplete &&
                  !isCurrent &&
                  "border-border bg-background text-muted-foreground",
              )}
            >
              {isComplete ? (
                <Check className="size-3" aria-hidden="true" />
              ) : (
                index + 1
              )}
            </span>
            <span
              className={cn(
                "text-[11.5px] font-medium",
                isCurrent ? "text-foreground" : "text-muted-foreground",
              )}
            >
              {step.label}
            </span>
            {index < steps.length - 1 ? (
              <span className="h-px w-4 bg-border" aria-hidden="true" />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
